import { createSelector } from '@ngrx/store';
import { docsFeature } from '../docs/docs.reducer';
import { docKey } from '../docs/docs.normalize';
import { selectActiveProjectId } from '../workspace/workspace.selectors';
import { ChatMessage } from './global-chat.models';

const { selectEntities, selectKeyIndex, selectStatusByKey, selectErrorByKey } = docsFeature;

function dataFor(
  entities: ReturnType<typeof selectEntities>,
  keyIndex: Record<string, string>,
  pid: string | null,
  key: string
): any {
  if (!pid) return null;
  const id = keyIndex[docKey(pid, key)];
  return id ? entities.entities[id]?.data ?? null : null;
}

export const selectGlobalChatMessages = createSelector(
  selectActiveProjectId,
  selectEntities,
  selectKeyIndex,
  (pid, e, k): ChatMessage[] => {
    const d = dataFor(e, k, pid, 'project.globalChat');
    return Array.isArray(d?.messages) ? (d.messages as ChatMessage[]) : [];
  }
);

export const selectGlobalChatLoading = createSelector(selectActiveProjectId, selectStatusByKey, (pid, s) =>
  pid ? s[docKey(pid, 'project.globalChat')] === 'loading' : false
);

export const selectGlobalChatError = createSelector(selectActiveProjectId, selectErrorByKey, (pid, e) =>
  pid ? e[docKey(pid, 'project.globalChat')] ?? null : null
);
